import { SosDetailsModal } from '@/components/atoms';
import { Table } from 'antd';
import { useState } from 'react';
import { useUsersByIdMessagesQuery } from './hooks';
const SosMessagesResults = ({ user_sos_messages_data, user_sos_messages_loading }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [messages, setMessages] = useState([172]);
    const users_id_arr = [];
    user_sos_messages_data.forEach((data) => {
        users_id_arr.push(data.user_id);
    });

    const userMessages = useUsersByIdMessagesQuery(users_id_arr);
    const data = userMessages.data ? userMessages.data.sosGetAllByUserIdMessages : [];

    const showModal = (e) => {
        const res = JSON.parse(e.currentTarget.getAttribute('data-column'));
        const filter_data = data.filter((message) => message.user_id === res.user_id);
        setMessages(filter_data);

        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const columns = [
        {
            title: 'User ID',
            dataIndex: 'user_id',
            key: 'user_id',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Total User Messages',
            dataIndex: 'total_messages',
        },
        {
            title: 'Details',
            dataIndex: '',
            render: (text, record) => <DetailsButton dataColumn={JSON.stringify(record)} onClick={showModal} />,
        },
    ];
    return (
        <>
            <Table bordered columns={columns} dataSource={user_sos_messages_data} loading={user_sos_messages_loading} pagination={false} rowKey="user_id" title={() => 'Top 10 Users'} />
            <SosDetailsModal handleCancel={handleCancel} isModalVisible={isModalVisible} messages={messages} page="sos" />
        </>
    );
};

const DetailsButton = ({ dataColumn, onClick }) => (
    <button style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} data-column={dataColumn} onClick={onClick}>
        Details
    </button>
);

export { SosMessagesResults };
